import { AppState } from '../store';

export const rulesValidationRunning = (state: AppState) => state.rulesValidation.running;

export const rulesValidationResults = (state: AppState) => state.rulesValidation.results;
